/**
 * CTA Parallax Effect
 * Alpine.js component for proper parallax background based on viewport position
 */

document.addEventListener('alpine:init', () => {
  Alpine.data('ctaParallax', () => ({
    parallaxOffset: 0,
    
    init() {
      this.handleScroll();
    },
    
    handleScroll() {
      const rect = this.$el.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      
      // Only apply parallax when element is in or near viewport
      if (rect.top < windowHeight && rect.bottom > 0) {
        // Calculate how far through the viewport the element is
        // This creates a smooth parallax effect relative to viewport position
        const elementCenter = rect.top + (rect.height / 2);
        const viewportCenter = windowHeight / 2;
        const distanceFromCenter = elementCenter - viewportCenter;
        
        // Apply parallax with reduced speed (0.2 = 20% of scroll speed)
        // Negative value moves background opposite to scroll direction
        this.parallaxOffset = -distanceFromCenter * 0.2;
      }
    }
  }));
});
